/**
 * Page fragment identifiers for quote list tabs.
 * These values are used in URLs (hash fragments) and for tab identification.
 * They are technical identifiers, not display labels (those come from localization).
 */
export const QuoteListPageFragments = {
  ALL_CURRENT: 'allCurrent',
  DRAFT: 'draft',
  ACTIVE: 'active',
  ISSUED: 'issued',
  ACCEPTED: 'accepted',
  UNDER_REVIEW: 'underreview',
  REVIEWED: 'reviewed',
  APPROVED: 'approved',
  ARCHIVED: 'archived',
  QUOTE_DEFAULTS: 'quotedefaults'
} as const;
